module.exports = __webpack_public_path__ + "static/media/moschino_portachiavi_2.e24429b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/moschino_portachiavi_2.png
// module id = 802
// module chunks = 0